// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-pf-btn {\n  font-size: 15px;\n  padding: 0.2rem 0.5rem;\n  /* position: absolute;\n  left: 50%;\n  transform: translateX(-50%); */\n  font-weight: 300;\n}\n\n.delete-pf-btn .trash {\n  margin-right: 0.5rem;\n  margin-bottom: 0.25rem;\n}\n", ""]);
// Exports
module.exports = exports;
